var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 54,
    fill: "#4BA1F0",
    stroke: "white",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6534 57.5947V59.423C78.6509 63.7084 77.2633 67.8781 74.6974 71.3104C72.1315 74.7427 68.5249 77.2536 64.4154 78.4687C60.3059 79.6837 55.9137 79.5378 51.8939 78.0527C47.8741 76.5676 44.442 73.8229 42.1096 70.2279C39.7772 66.6329 38.6693 62.3802 38.9513 58.1041C39.2332 53.828 40.8899 49.7576 43.6742 46.5C46.4585 43.2424 50.2212 40.9721 54.4012 40.0277C58.5812 39.0833 62.9546 39.5153 66.8689 41.2595",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6547 43.5264L58.7821 63.4188L52.8203 57.457",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0a5fe95a54f4756b9df166f16f9aebd1.svg";
export { ForwardRef as ReactComponent };